module.exports = __webpack_public_path__ + "static/media/hyperx_black1.53d5d446.png";